import type { ArtistCreditAccount, ArtistsCreditAccountResponse } from '../types';
import { mapCreditAccount } from './creditAccountMapper';

export const mapArtistCreditAccount = (response: ArtistsCreditAccountResponse): ArtistCreditAccount => {
  return {
    artist: {
      id: response.artist.id,
      name: response.artist.name,
      profileImageUrl: response.artist.facecoin_image_url || response.artist.profile_vertical_image_url,
    },
    creditAccount: mapCreditAccount(response.credit_account),
  };
};
